import actions from '@/core/store/ata/documentos-ata/documentos/editor-texto/actions'

export default { actions }
